export default {
  MAIN_DETAILS_DIALOG: {
    CANCEL: {
      title: 'Do you want to cancel the ETP?',
      text: "By cancelling the ETP you will also cancel the original Payables Financing request. You can't undo this action later.",
      btn: 'CANCEL ETP'
    },
    DEFAULT: {
      title: 'Do you want to set this ETP as Defaulted?',
      text: "You should default the ETP only if you are going to start collecting the full remaining amount instead of single instalments. You can't undo this action later.",
      btn: 'DEFAULT'
    },
    WRITE_OFF: {
      title: 'Do you want to set this ETP as Written off?',
      text: "You should write off the ETP only if you are expecting to get no more payments. You can't undo this action later.",
      btn: 'WRITE OFF'
    }
  },
  MANUAL_BID_DIALOG: {
    title: 'Manual Bid:',
    main_text:
      'Manual bids are not reversible. Double check your input before confirming the bid.',
    cta: 'Add bid',
    cancel: 'Cancel',
    success: 'Bid successfully placed.',
    input_labels: {
      selected_investor: 'Investor',
      selected_account: 'Trading Account',
      selected_account_hint: 'This field is mandatory',
      account_balance: 'Account Available Balance',
      etp_amount: 'ETP Amount',
      pending_amount: 'Pending Amount',
      bid_size: 'Bid Size'
    },
    validation: {
      not_number: 'Bid Size should be a number',
      bid_size_exceeded: 'Can’t exceed pending amount',
      bid_size_exceeds_balance: 'Can’t exceed available balance',
      bid_size_higher_than_10: 'Minimum allowed amount is 10'
    }
  }
}
